import React, { useState } from 'react';
import { Modal } from '@/components/ui/Modal/Modal';
import { Input } from '@/components/ui/Input/Input';
import { Button } from '@/components/ui/Button/Button';

interface CreatePresetModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (name: string) => void;
  loading?: boolean;
  duplicatingName?: string;
}

export function CreatePresetModal({
  isOpen, onClose, onConfirm, loading, duplicatingName,
}: CreatePresetModalProps) {
  const [name, setName] = useState(duplicatingName ? `${duplicatingName} (copy)` : '');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    onConfirm(trimmed);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={duplicatingName ? 'Duplicate Preset' : 'Create New Preset'}
      size="sm"
    >
      <form onSubmit={handleSubmit} className="space-y-4 p-4">
        <Input
          label="Preset Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. Corporate Blue"
          autoFocus
        />
        <p className="text-xs text-muted-foreground">
          {duplicatingName
            ? `All theme values from "${duplicatingName}" will be copied to the new preset.`
            : 'The current form values will be saved as this new preset.'}
        </p>
        <div className="flex justify-end gap-3 pt-2">
          <Button type="button" variant="outline" onClick={onClose}>Cancel</Button>
          <Button type="submit" variant="primary" loading={loading} disabled={!name.trim()}>
            {duplicatingName ? 'Duplicate' : 'Create'}
          </Button>
        </div>
      </form>
    </Modal>
  );
}
